import { graphql } from 'gql';

export const actKc2TotalDetailsGql = graphql(`
    query bimActKC2Totals(
        $skip: Int
        $take: Int
        $actKC2Id: Long!
        $readOnly: Boolean
        $where: BimActKC2TotalItemDataFilterInput
        $order: [BimActKC2TotalItemDataSortInput!]
    ) {
        bimActKC2Totals(
            skip: $skip
            take: $take
            actKC2Id: $actKC2Id
            readOnly: $readOnly
            where: $where
            order: $order
        ) {
            totalCount
            items {
                id
                totalId
                workOrderSeasonId
                workOrderActiveSeasonId
                name
                smrTotal
                ozp
                emm
                zpm
                tzr
                sortOrder
                parentId
                isEditable
                isInflation
                isLimitPrice
                limitedCostType
                isSelected
                isInputValue
                isInflation
            }
        }
    }
`);

export const updateActTotalLimitedGql = graphql(`
    mutation bimUseActKC2TotalLimited(
        $actKC2Id: Long!
        $limitedItems: [BimLimitedCostTypeEnum!]!
        $useLimited: Boolean!
    ) {
        bimUseActKC2TotalLimited(actKC2Id: $actKC2Id, limitedItems: $limitedItems, useLimited: $useLimited) {
            result
            message

            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const resetActKC2CalculatedTotalAllGql = graphql(`
    mutation bimResetActKC2AllCalculatedTotal($actKC2Id: Long!, $useCalculated: Boolean!) {
        bimResetActKC2AllCalculatedTotal(actKC2Id: $actKC2Id, useCalculated: $useCalculated) {
            result
            message
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const resetActKC2CalculatedTotalItemGql = graphql(`
    mutation bimResetActKC2CalculatedTotalItem($actKC2Id: Long!, $useCalculated: Boolean!, $actKC2TotalItemId: Long!) {
        bimResetActKC2CalculatedTotalItem(
            actKC2Id: $actKC2Id
            useCalculated: $useCalculated
            actKC2TotalItemId: $actKC2TotalItemId
        ) {
            result
            message
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const setActKC2InputValueGql = graphql(`
    mutation bimSetActKC2InputValue($actKC2Id: Long!, $actKC2TotalItemId: Long!, $value: Decimal!) {
        bimSetActKC2InputValue(actKC2Id: $actKC2Id, actKC2TotalItemId: $actKC2TotalItemId, value: $value) {
            result
            message
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const bimActKC2PriceRowsGql = graphql(`
    query bimActKC2PriceRows(
        $skip: Int
        $take: Int
        $actKC2Id: Long!
        $priceLevel: BimPriceLevelEnum!
        $where: BimActKC2PriceRowDataFilterInput
        $order: [BimActKC2PriceRowDataSortInput!]
    ) {
        bimActKC2PriceRows(
            skip: $skip
            take: $take
            actKC2Id: $actKC2Id
            priceLevel: $priceLevel
            where: $where
            order: $order
        ) {
            totalCount
            items {
                id
                name
                sectionId
                sectionName
                serialNumber
                number
                code
                unit
                quantity
                unitCost
                total
                inactiveMtr
            }
        }
    }
`);

export const bimUseActKC2TotalInflationGql = graphql(`
    mutation bimUseActKC2TotalInflation($actKC2Id: Long!, $workOrderSeasonId: Long!) {
        bimUseActKC2TotalInflation(actKC2Id: $actKC2Id, workOrderSeasonId: $workOrderSeasonId) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            actionRequired
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const bimUseActKC2InflationValueGql = graphql(`
    mutation bimUseActKC2InflationValue($actKC2Id: Long!, $calculateInflation: BimCalculateInflationEnum!) {
        bimUseActKC2InflationValue(actKC2Id: $actKC2Id, calculateInflation: $calculateInflation) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            actionRequired
            validation {
                property
                message
                metadata
            }
        }
    }
`);
